import { render, staticRenderFns } from "./NotificationsCreate.html?vue&type=template&id=101f21c2&external"
import script from "./NotificationsCreate.vue?vue&type=script&lang=js"
export * from "./NotificationsCreate.vue?vue&type=script&lang=js"
import style0 from "./NotificationsCreate.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports